import { assertPlatform, Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { AlarmConfig, DistributionList, MessageTemplate, SiteTwin, SiteType, TimeSeriesAlarm, TimeSeriesVariable, VirtualTimeSeries, VirtualTimeSeriesRecord } from 'src/api/models';
import { TimeSeriesAlarmService, CustomerService, DistributionListService, MessageTemplateService, VirtualTimeSeriesService, SiteTypeService } from 'src/api/services';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ToastrService } from 'ngx-toastr';
import { AzureAuthService } from 'src/service/azure-auth.service';

@Component({
  selector: 'app-virtual-time-series-editor',
  templateUrl: './virtual-time-series-editor.component.html',
  styleUrls: ['./virtual-time-series-editor.component.scss']
})
export class VirtualTimeSeriesEditorComponent implements OnInit {
  @Input() siteType: SiteType;
  @Input() virtualTimeSeries: VirtualTimeSeriesRecord;
  sites: SiteTwin[];
  //@Input() siteUri: string;
  //@Input() siteTypeId: number;

  canSave(): boolean{
    return this.virtualTimeSeries != null && this.virtualTimeSeries.name != null && this.virtualTimeSeries.name != '' && this.virtualTimeSeries.config.expression != null && this.virtualTimeSeries.config.expression != '';
  }
  
  constructor(public service: VirtualTimeSeriesService,
    private app: ApplicationConfigService, 
    private siteTypeService: SiteTypeService,
    public azureAuthService: AzureAuthService,
    private toasterService: ToastrService) {
      
  }

  ngOnInit() {
    this.siteTypeService.SiteTypeSearch({ type:this.siteType.siteTypeCode, customerId: this.siteType.customerId, search: '', searchSize: 100, pageIndex: 0, filterOld: true})
    .subscribe(r => {
      this.sites = r;
    });
  }

  removeMetaTag(key: string) {
    delete this.virtualTimeSeries.metaData[key];
  }

  newMetaTag: string;
  newMetaValue: string;
  addNewMetaTag(){
    if (this.newMetaTag == null) return;
    if (this.virtualTimeSeries.metaData == null){
      this.virtualTimeSeries.metaData = {};
    }
    this.virtualTimeSeries.metaData[this.newMetaTag] = this.newMetaValue;
    this.newMetaTag = null;
    this.newMetaValue = null;
  }

  removeNewMetaTag(){
    this.newMetaTag = null;
    this.newMetaValue = null;
  }

  findVariables(){
    if (this.virtualTimeSeries.config.expression){
      if (this.virtualTimeSeries.config.variables == null){
        this.virtualTimeSeries.config.variables = {};
      }
      console.log("Evaluation variables for expression: " + this.virtualTimeSeries.config.expression);
      this.service.VirtualTimeSeriesParseExpression(this.virtualTimeSeries.config.expression).subscribe(r => {
        for (let v of r){
          if (this.virtualTimeSeries.config.variables[v] == null) {
            this.virtualTimeSeries.config.variables[v] = {name:v, transforms:[]} as TimeSeriesVariable
          } else {
              
          }
          // do we delete any?
        }
        for (const [key, value] of Object.entries(this.virtualTimeSeries.config.variables)) {
          if (!r.find(i => i == key)){
            delete this.virtualTimeSeries.config.variables[key]
            //this.virtualTimeSeries.config.variables[key] = null;
          }
        }
      });
    }
  }

  save(){
    if (this.virtualTimeSeries.id != null) {
      console.log('VirtualTimeSeries', this.virtualTimeSeries);
      this.service.VirtualTimeSeriesUpdateVirtualTimeSeries(this.virtualTimeSeries).subscribe(r => {
        this.virtualTimeSeries.id = r.id;
        this.toasterService.success("Virtual Time Series Created");
      }, err => {
        this.toasterService.error("Virtual Time Series Not Created");
      });
    } else {
      this.service.VirtualTimeSeriesCreateVirtualTimeSeries(this.virtualTimeSeries).subscribe(r => {
        this.virtualTimeSeries.id = r.id;
        this.toasterService.success("Virtual Time Series Updated");
      }, err => {
        this.toasterService.error("Virtual Time Series Not Updated");
      });
    }
  }

  cancel(){
    this.virtualTimeSeries = null;
  }

  delete(){
    this.service.VirtualTimeSeriesDeleteVirtualTimeSeries({customerId: this.app.customerId,  id: this.virtualTimeSeries.id}).subscribe(d => {
      this.toasterService.success("Virtual Time Series Deleted");
      this.virtualTimeSeries = null;
    }, err => {
      this.toasterService.error("Failed to delete Virtual Time Series");
    })
  }
}
